import { useMemo, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import sealImg from "../../../resources/bhu-seal.png";
import { printHtml } from "../../../utils/printHtml";
import { applicationFormData, FORM_KINDS } from "./applicationFormData";
import { applicationFormHtml } from "./formTemplates";

/* Prints the guest house's own paper application form with this booking's
   details filled in — the SSB, Faculty or LD/UGH form, picked by the house
   the booking is for. */
export default function PrintApplicationFormButton({ booking, guestHouses, paymentOptions }) {
  const [failed, setFailed] = useState(false);
  const data = useMemo(
    () => applicationFormData(booking, { guestHouses, paymentOptions }),
    [booking, guestHouses, paymentOptions],
  );

  const handlePrint = () => {
    /* Absolute, since the iframe document is written rather than loaded. */
    const sealUrl = new URL(sealImg, window.location.origin).href;
    const title = `Application form ${data.bookingCode || ""}`.trim().replace(/[\\/]/g, "-");
    setFailed(!printHtml(applicationFormHtml(data, { sealUrl, generatedAt: new Date() }), title));
  };

  return (
    <Button
      basic
      color={failed ? "red" : "blue"}
      size="small"
      type="button"
      onClick={handlePrint}
      title={`Print the ${FORM_KINDS[data.kind]} application form with this booking's details`}
    >
      <Icon name="print" />
      {failed ? "Print failed" : "Print Form"}
    </Button>
  );
}
